import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { ThemeService } from 'src/app/shared/services/theme/theme';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {
    private router = inject(Router);
    private auth = inject(AuthService);
    private theme = inject(ThemeService);

    @Output() toggleSidebar = new EventEmitter<void>();
    @ViewChild('profile', { static: true }) profileRef!: ElementRef<HTMLElement>;

    menuOpen = false;
    currentTheme: 'light' | 'dark' = 'light';

    ngOnInit(): void {
        this.currentTheme = this.theme.getTheme();
    }

    toggleMenu(): void {
        if (this.hoverTimer) { clearTimeout(this.hoverTimer); this.hoverTimer = null; }
        this.menuOpen = !this.menuOpen;
    }
    closeMenu(): void { this.menuOpen = false; }

    private hoverTimer: any;
    onProfileEnter(): void {
        if (this.hoverTimer) { clearTimeout(this.hoverTimer); this.hoverTimer = null; }
        this.menuOpen = true;
    }
    onProfileLeave(): void {
        if (this.hoverTimer) clearTimeout(this.hoverTimer);
        this.hoverTimer = setTimeout(() => this.menuOpen = false, 150);
    }

    toggleTheme(): void {
        this.currentTheme = this.currentTheme === 'light' ? 'dark' : 'light';
        this.theme.setTheme(this.currentTheme);
    }

    onLogout(): void {
        this.auth.logout();
        this.router.navigateByUrl('/auth', { replaceUrl: true });
    }

    @HostListener('document:click', ['$event'])
    onDocClick(ev: MouseEvent): void {
        if (!this.menuOpen) return;
        const t = ev.target as Node;
        if (this.profileRef && this.profileRef.nativeElement.contains(t)) return;
        this.menuOpen = false;
    }

    @HostListener('document:keydown.escape')
    onEsc(): void { this.menuOpen = false; }
}
